import React from 'react';
import { Skeleton } from '@mui/material';

interface FieldSkeletonLayoutProps {
    ultraLongText?: boolean;
    longText?: boolean;
    small?: boolean;
    style?: { [key: string]: string | number };
}

const FieldSkeletonLayout = ({
    ultraLongText = false,
    longText = false,
    small = false,
    style = {},
}: FieldSkeletonLayoutProps) => {
    return (
        <Skeleton
            variant="rectangular"
            height={ultraLongText ? 133 : longText ? 108 : small ? 48 : 56}
            sx={style}
        />
    );
};

export default FieldSkeletonLayout;
